import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import unmuteImg from '../modules/connect-card-widget/assets/sound-on3.png';
import playImg from '../modules/connect-card-widget/assets/big-play-button.png';

const useStyles = makeStyles(() => ({
  video: {
    'position': 'relative',
    'paddingTop': '56.25%',
    '& .react-player': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
  videoWrapper: {
    position: 'relative',
  },
  overlay: {
    'padding': 10,
    'position': 'absolute',
    'zIndex': 1,
    'cursor': 'pointer',
    'left': 0,
    'right': 0,
    'top': 0,
    'bottom': 0,
    'backgroundImage': `url('${playImg}')`,
    'backgroundSize': '20%',
    'backgroundPosition': 'center',
    'backgroundRepeat': 'no-repeat',
    '& .unmute-button': {
      'width': '100px',
      'marginTop': 20,
      '& img': {
        width: '100%',
        height: 'auto',
      },
    },
  },
}));

const VideoPlayer = ({ url, autoplay }) => {
  const classes = useStyles();
  const [playing, setPlaying] = useState(autoplay);
  const playerRef = useRef();

  const unmutePlay = () => {
    if (playerRef.current) {
      setPlaying(true);
      playerRef.current.seekTo(0);
    }
  };

  return (
    <Box className={classes.videoWrapper}>
      {!playing && (
        <Box className={classes.overlay} onClick={unmutePlay}>
          <div className="unmute-button">
            <img src={unmuteImg} />
          </div>
        </Box>
      )}
      <Box className={classes.video}>
        <ReactPlayer
          playing
          controls
          stopOnUnmount
          muted={!playing}
          volume={playing ? 1 : 0}
          ref={playerRef}
          pip={false}
          className="react-player"
          width="100%"
          height="100%"
          url={url}
        />
      </Box>
    </Box>
  );
};

export default VideoPlayer;
